import { useAtomValue, useSetAtom } from 'jotai';

import {
  quickAddStartTimeAtom,
  quickAddDateAtom,
  closePanelAtom,
  panelsAtom,
  schedulingTaskAtom,
} from '@/stores/panels';
import { ResponsivePanelWrapper } from '@/components/ui/ResponsivePanelWrapper';
import { QuickAddContent, NewBlockData } from './QuickAddContent';

interface QuickAddPanelProps {
  onSave: (block: NewBlockData) => void;
}

export function QuickAddPanel({ onSave }: QuickAddPanelProps) {
  const startTime = useAtomValue(quickAddStartTimeAtom);
  const initialDate = useAtomValue(quickAddDateAtom);
  const schedulingTask = useAtomValue(schedulingTaskAtom);
  const panels = useAtomValue(panelsAtom);
  const closePanel = useSetAtom(closePanelAtom);
  const setSchedulingTask = useSetAtom(schedulingTaskAtom);

  const handleClose = () => {
    closePanel('quickAdd');
    setSchedulingTask(null);
  };

  const handleSave = (block: NewBlockData) => {
    onSave(block);
    setSchedulingTask(null);
  };

  return (
    <ResponsivePanelWrapper
      panelId="quickAdd"
      title={schedulingTask ? 'Schedule Task' : 'New Block'}
    >
      <QuickAddContent
        isOpen={panels.quickAdd.isOpen}
        initialStartTime={startTime}
        initialDate={initialDate}
        schedulingTask={schedulingTask}
        onClose={handleClose}
        onSave={handleSave}
      />
    </ResponsivePanelWrapper>
  );
}
